import { useState, useCallback, useEffect } from 'react';
import { Container, BoxSelect, BtnSearch, Content } from './styled';
import { apiAdmin } from '../../../../service/api';
import { DatePicker, InputList, Table } from '../../../../components';
import { RiCustomerService2Fill, RiTimerLine } from 'react-icons/ri';
import { IoIosSearch } from 'react-icons/io';
import { FaUsers } from 'react-icons/fa';
import { MdDateRange } from 'react-icons/md';
import moment from 'moment';
import * as XLSX from 'xlsx';


export function TimeWaitGroup() {

    const [dateStart, setDateStart] = useState(moment(`${new Date().getMonth() + 1}-${new Date().getDate()}-${new Date().getFullYear()}`).format('YYYY-MM-DD'));
    const [dateEnd, setDateEnd] = useState(moment(`${new Date().getMonth() + 1}-${new Date().getDate()}-${new Date().getFullYear()}`).format('YYYY-MM-DD'));
    const vision_type = [
        {
            id: 0,
            name: 'Tempo de espera - Mensal',
            valor: 'M'
        },
        {
            id: 1,
            name: 'Tempo de espera - Semanal',
            valor: 'W'
        }, {
            id: 2,
            name: 'Tempo de espera - Diário',
            valor: 'D'
        }
    ];
    const [visionTypeSelected, setVisionTypeSelected] = useState({
        id: 0,
        name: 'Tempo de espera - Mensal',
        valor: 'M'
    });
    const [data, setData] = useState([]);
    const [dataTable, setDataTable] = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState('');


    const searchQTDCustomerService = useCallback(async (dt_ini, dt_fim, type) => {
        setLoading(true)
        const { data } = await apiAdmin.post(`/tempo-de-espera-grupo?dt_ini=${dt_ini}&dt_fim=${dt_fim}&tipo_visao=${type}`);
        setData(data)
        setDataTable(data)
        setLoading(false)
    }, []);
    useEffect(() => {
        searchQTDCustomerService(
            moment(dateStart).format('DD/MM/YYYY'),
            moment(dateEnd).format('DD/MM/YYYY'),
            visionTypeSelected.valor
        )
    }, [])
    useEffect(() => {
        if (search) return
        setDataTable(data)
    }, [search])

    const clear = () => {
        setData([])
        setDataTable([])
    }

    const componentPeriodo = (rowData) => {
        const primeiraChave = Object.keys(rowData)[0];
        return (
            <span className='column'>
                <MdDateRange />
                {rowData[primeiraChave]}
            </span>
        )
    }
    const componentSetores = (rowData) => {
        return (
            <span className='column'>
                <FaUsers />
                {rowData.setor}
            </span>
        )

    }

    const onFormatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = Math.floor(seconds % 60);

        const formattedMinutes = String(minutes).padStart(2, '0');
        const formattedSeconds = String(remainingSeconds).padStart(2, '0');

        return `${formattedMinutes}:${formattedSeconds}`;
    };
    const componentTempoMedio = (rowData) => {
        return (
            <span className='column'>
                <RiTimerLine />
                {onFormatTime(rowData.tempo_medio)}
            </span>
        )
    }
    const componentTotalCustomerService = (rowData) => {
        return (
            <span className='column'>
                <RiCustomerService2Fill />
                {rowData.total_atendimento}
            </span>
        )

    }


    function onFilter() {
        if (!search) return
        var aux = data.filter((obj) => {
            return obj.setor?.toLowerCase()?.includes(search?.toLowerCase())
                || obj.tempo_medio === parseInt(search)
                || obj.total_atendimento === parseInt(search)
        });
        setDataTable([...aux])
    }
    function onGeneratorExcel() {
        const workbook = XLSX.utils.table_to_book(document.getElementById("IDtable"));
        XLSX.writeFile(workbook,
            `Pesquisa de ${moment(dateStart).format('DD/MM/YYYY')} a ${moment(dateEnd).format('DD/MM/YYYY')}.xlsx`
        );

    }

    return (
        <Container>
            <BoxSelect>
                <div className='box--'>
                    <div className='line-'>
                        <DatePicker className="date" value={dateStart} onChange={setDateStart} onClick={() => { clear() }} />
                        <span> - </span>
                        <DatePicker className="date" value={dateEnd} onChange={setDateEnd} onClick={() => { clear() }} />
                    </div>
                    <div className='line-'>
                        <div className='list-'>
                            <InputList
                                options={vision_type}
                                value={visionTypeSelected?.name}
                                onChange={(e) => { setVisionTypeSelected(e) }}
                                toView={'name'}
                            />
                        </div>
                        <BtnSearch
                            onClick={() => {
                                searchQTDCustomerService(
                                    moment(dateStart).format('DD/MM/YYYY'),
                                    moment(dateEnd).format('DD/MM/YYYY'),
                                    visionTypeSelected.valor
                                )
                            }}
                        >
                            {loading ? <span className='loader' /> : <IoIosSearch />}
                        </BtnSearch>
                    </div>
                </div>
            </BoxSelect>
            <Content>
                <div className='area--table'>
                    <Table
                        id={`IDtable`}
                        data={dataTable}
                        keyLine={`id`}
                        column={[
                            { key: 0, title: 'Período', component: componentPeriodo },
                            { key: 1, title: 'Setores', component: componentSetores },
                            { key: 2, title: 'Tempo Medio', component: componentTempoMedio },
                            { key: 3, title: 'Total de Atendimentos', component: componentTotalCustomerService }
                        ]}
                        search={search}
                        setSearch={setSearch}
                        onFilter={onFilter}
                        onGeneratorExcel={onGeneratorExcel}
                    />
                </div>
            </Content>
        </Container >
    );
}
